import { Currencies, Currency } from '@column/column-ui-kit';

import countryCodeJSON from '~/data/wires/country-codes.json';
import { CreateCounterparty, FinancialInstitution, ValidateIBANObject } from '~/repositories';

type TemporaryData = {
  institution: FinancialInstitution | null;
  iban: ValidateIBANObject | null;
  currency: Currency | null;
  oldCounterpartyId: string | null;
};

export type FormData = CreateCounterparty & { temporaryData: TemporaryData };

/** One entry per country, by name: the JSON is ordered by currency code and lists Sierra Leone under both of its. */
export const COUNTRIES = countryCodeJSON
  .filter((entry, i, all) => all.findIndex((e) => e.countryCode === entry.countryCode) === i)
  .sort((a, b) => a.countryName.localeCompare(b.countryName));

export const countryName = (countryCode?: string) =>
  countryCodeJSON.find((entry) => entry.countryCode === countryCode)?.countryName;

export const currencyForCountry = (countryCode?: string) => {
  const currencyCode = countryCodeJSON.find((entry) => entry.countryCode === countryCode)?.currencyCode;
  return Currencies.find(({ code }) => code === currencyCode) ?? null;
};
